import { BranchType, ServiceBookingService } from 'api-new/generated';
import { QueryError } from 'features/shared/model';
import { UseMutationOptions, useMutation } from 'react-query';

export type VehicleImportInput = {
  branch?: BranchType;
  vehicleId?: string;
};

export const useVehicleImportMutation = (
  options?: Omit<
    UseMutationOptions<
      Awaited<ReturnType<typeof ServiceBookingService.getServiceBookingVehicleImport>>,
      QueryError,
      VehicleImportInput,
      unknown
    >,
    'mutationFn'
  >
) =>
  useMutation((input: VehicleImportInput) => {
    return ServiceBookingService.getServiceBookingVehicleImport(input.branch, input.vehicleId);
  }, options);
